module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAABWCAYAAADom/XHAAAABHNCSVQICAgIfAhkiAAAAPxJREFUeJzt1DFtA0EURdE7q+AIkkQyl9RmEKNwHSxZGK5NZExhm9UUPqf+xSuu/vj6ffyP0SXe0pztmwDe2xhdttUjWE8EiAARkAhIBCQCEgHVx9HD+8/nmTs4wfXveejOJ0AEiIBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAhIBiYBEQCIgEZAISAQkAqrxfXvM1SNYyydABIiAREAiIBGQCEgEVNuc7atHsM6c7S/6hxGNpvrp+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/media/AnnoType_Area.png
// module id = 677
// module chunks = 2